<template>
    <taplink-swiper :has-pagination="content.slides.length > 1">
        <taplink-swiper-item v-for="item of content.slides" :key="item.id" class="slider-item">
            <div class="slider-item-wrap">
                <div class="slider-item-picture" :style="{ paddingTop: content.slideSize + '%' }">
                    <div
                        v-if="item.image"
                        class="slider-item__img"
                        :style="{ backgroundImage: `url('${item.image.url}')` }"
                    ></div>
                    <div v-else class="slider-item__empty">
                        <v-icon src="image" />
                    </div>
                </div>
                <div class="slider-item-description" v-if="content.desc">
                    <div class="slider-item-title" v-html="item.desc.title || 'Заголовок'"></div>
                    <div class="slider-item-text" v-html="item.desc.text"></div>
                </div>
                <div class="slider-item-link" v-if="content.link" v-html="item.link.label || 'Открыть'"></div>
            </div>
        </taplink-swiper-item>
    </taplink-swiper>
</template>

<script>
import TaplinkSwiper from "../common/taplink-swiper/TaplinkSwiper";
import TaplinkSwiperItem from "../common/taplink-swiper/TaplinkSwiperItem";

export default {
    name: "TapSlider",
    components: {
        TaplinkSwiper,
        TaplinkSwiperItem
    },
    props: {
        content: {}
    }
};
</script>

<style scoped lang="scss">
.slider-item {
    overflow: hidden;
    border-radius: 5px;
    border: 1px solid rgba(#000, 0.07);
    &-wrap {
        border-radius: 5px;
        overflow: hidden;
    }
    &-picture {
        position: relative;
        width: 100%;
        border-bottom: 1px solid rgba(#000, 0.07);
    }
    &__img {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
    }
    &__empty {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        .svg-icon {
            font-size: 100px;
        }
    }
    &-description {
        background: #fff;
        padding: 14px;
        /*border-bottom: 1px solid rgba(0, 0, 0, 0.1);*/
        border-top: none;
    }

    &-title {
        font-size: 18px;
        line-height: 1.5;
    }

    &-text {
        font-size: 14px;
        opacity: 0.7;
        white-space: pre-line;
    }

    &-link {
        font-size: 16px;
        padding: 17px 20px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        text-align: center;
        background: #fff;
        color: #0383de;
    }
}
</style>
